module.exports = (__webpack_public_path__ || '') + "static/images/int-banner-min-2374ee9b0616375d43f2ecc1c5b20cbc.jpg";